import { memo } from 'react'

import { GitSha } from './GitSha'
import { TopNav } from './TopNav'
import { DataDog } from '@components/DataDog'
import { GlobalDialogListener } from '@components/ui/Dialog/GlobalDialogListener'
import { RumViewTracker } from '@features/observability/RumViewTracker'
import { cn } from '@lib/cn'
import { SonnerToaster } from '@ui/Toast/Sonner'
import { ToastErrorListener } from '@ui/Toast/ToastErrorListener'

export const maxWidthLayoutCSS = 'max-w-8xl mx-auto'
const maxWidthBorderCSS = '8xl:border-x 8xl:border-input'
export const pageHightCss = 'flex flex-col lg:h-[calc(100vh-80px)] max-h-[calc(100vh-80px)] pt-4 px-5'

export const DefaultLayoutHelpers = memo(() => (
  <>
    <DataDog />
    <RumViewTracker />
    <GitSha />
    <SonnerToaster />
    <ToastErrorListener />
    <GlobalDialogListener />
  </>
))

export const PageTemplate = memo(({ children }: { children: React.ReactNode }) => (
  <div
    className={cn(
      'h-screen w-screen overflow-hidden flex flex-col bg-background',
      maxWidthLayoutCSS,
      maxWidthBorderCSS,
    )}
  >
    <header className='fixed top-0 left-0 right-0 z-50 h-20 w-full px-4 flex items-center'>
      <TopNav />
    </header>

    <main className='flex-1 flex overflow-hidden pt-20'>{children}</main>
  </div>
))
